import styled, { css } from 'styled-components';

const Cell = styled.td`
  ${(props) =>
    props.fixed &&
    css`
      position: sticky;
      z-index: 3;
      background-color: white;

      width: ${() => props.width};
      left: ${() => props.left};
    `}
`;

export default Cell;
